import { Effect } from "../Materials/effect";
var name = 'hdrFilteringVertexShader';
var shader = "\nattribute vec2 position;\n\nvarying vec3 direction;\n\nuniform vec3 up;\nuniform vec3 right;\nuniform vec3 front;\nvoid main(void) {\nmat3 view=mat3(up,right,front);\ndirection=view*vec3(position,1.0);\ngl_Position=vec4(position,0.0,1.0);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var hdrFilteringVertexShader = { name: name, shader: shader };
//# sourceMappingURL=hdrFiltering.vertex.js.map